import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import * as memberAction from '../../../../redux/actions/member.action';
import './enableAppSettings.scss';

const EnableAppSettings = () => {
  const dispatch = useDispatch();
  const { entityId } = useParams();
  const [isEnabled, setIsEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const { memberDetails } = useSelector((state) => ({
    memberDetails: state.member.memberDetails,
  }));

  useEffect(() => {
    if (memberDetails) {
      setIsEnabled(memberDetails.enable_app || false);
    }
  }, [memberDetails]);

  const handleToggleChange = async () => {
    setIsLoading(true);
    setShowSuccessAlert(false);
    setShowErrorAlert(false);
    setErrorMessage('');

    try {
      const newStatus = !isEnabled;
      const formData = new FormData();
      
      // Create the updated member object
      const formBody = {
        ...memberDetails,
        enable_app: newStatus
      };

      formData.append("location", JSON.stringify(formBody));
      
      await memberAction.update(dispatch, entityId, formData);
      
      // Update local state
      setIsEnabled(newStatus);
      
      // Show success message
      setShowSuccessAlert(true);
      setTimeout(() => setShowSuccessAlert(false), 3000);
      
      // Refresh member details
      memberAction.fetchDetails(dispatch, entityId);
      
    } catch (error) {
      console.error('Error updating app access setting:', error);
      setErrorMessage('Failed to update app access setting. Please try again.');
      setShowErrorAlert(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="enable-app-settings">
      <div className="enable-app-header">
        <h4>App Access Settings</h4>
        <p className="text-muted">
          Configure whether this member location should have access to the mobile app.
        </p>
      </div>

      {showSuccessAlert && (
        <Alert 
          variant="success" 
          onClose={() => setShowSuccessAlert(false)}
          dismissible
        >
          App access setting updated successfully!
        </Alert>
      )}

      {showErrorAlert && (
        <Alert 
          variant="danger" 
          onClose={() => setShowErrorAlert(false)}
          dismissible
        >
          {errorMessage}
        </Alert>
      )}

      <div className="enable-app-content">
        <div className="setting-item">
          <div className="setting-info">
            <h5>Enable App Access</h5>
            <p className="text-muted">
              When enabled, this member location will have access to the mobile application features.
            </p>
          </div>
          
          <div className="setting-control">
            <Form.Check
              type="switch"
              id="enable-app-toggle"
              label={isEnabled ? "Enabled" : "Disabled"}
              checked={isEnabled}
              onChange={handleToggleChange}
              disabled={isLoading}
              className="custom-switch"
            />
          </div>
        </div>

        <div className="setting-status">
          <strong>Current Status: </strong>
          <span className={`status-badge ${isEnabled ? 'enabled' : 'disabled'}`}>
            {isEnabled ? 'App Access Enabled' : 'App Access Disabled'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default EnableAppSettings;